import React from "react";
import { Link } from "react-router-dom";
import moment from "moment/moment";

const News = (props) => {
    let newsArray = [];

    const convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds(),
        );
        const localTime = new Date(milliseconds);

        let cd = localTime.getFullYear() + "-" + (localTime.getMonth() + 1) + "-" + localTime.getDate() + " " + localTime.getHours() + ":" + localTime.getMinutes() + ":" + localTime.getSeconds();
        return moment(cd).format('DD MMMM YYYY h:mm A');
    };

    const important = () => {
        return (
            <div className="blinking-svg">
                <style>
                    {`
                        @keyframes blink {
                            0% {
                            opacity: 1;
                            }
                            50% {
                            opacity: 0;
                            }
                            100% {
                            opacity: 1;
                            }
                        }

                        .blinking-svg {
                            animation: blink 1s infinite;
                        }
                    `}
                </style>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1" viewBox="0 0 48 48" enableBackground="new 0 0 48 48" height="1.3em" width="1.3em" xmlns="http://www.w3.org/2000/svg"><path fill="#F44336" d="M21.2,44.8l-18-18c-1.6-1.6-1.6-4.1,0-5.7l18-18c1.6-1.6,4.1-1.6,5.7,0l18,18c1.6,1.6,1.6,4.1,0,5.7l-18,18 C25.3,46.4,22.7,46.4,21.2,44.8z"></path><path fill="#fff" d="M21.6,32.7c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.5-0.7c0.2-0.2,0.5-0.4,0.8-0.5s0.6-0.2,1-0.2 s0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.8,0.5c0.2,0.2,0.4,0.4,0.5,0.7c0.1,0.3,0.2,0.6,0.2,0.9s-0.1,0.6-0.2,0.9s-0.3,0.5-0.5,0.7 c-0.2,0.2-0.5,0.4-0.8,0.5c-0.3,0.1-0.6,0.2-1,0.2s-0.7-0.1-1-0.2s-0.5-0.3-0.8-0.5c-0.2-0.2-0.4-0.4-0.5-0.7S21.6,33.1,21.6,32.7z M25.8,28.1h-3.6L21.7,13h4.6L25.8,28.1z"></path></svg>
            </div>
        )
    }

    const renderNewsItem = (news) => (
        <li>
            <Link to="#">
                <div className="news-item-header">
                    <style>
                        {`
                            .news-item-header {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                            }
        
                            .important-icon {
                                margin-left: 10px;
                            }
                        `}
                    </style>
                    <p className="sub-title text--10">{convertUTCToLocalTime(news.created_at)}</p>
                    {news.important === 1 && <div className="important-icon">{important()}</div>}
                </div>
                <p className="text--13"><strong>{news.title}</strong></p>
                <p className="text--13">{news.description}</p>
            </Link>
        </li>
    );

    const renderNewsList = props.recentNews.map(news => renderNewsItem(news));

    return (
        <div className="margin--40--bot">
            <h3 className="sub-title text--muted">News</h3>
            <ul className="list--box list--news">
                {renderNewsList}
            </ul>
        </div>
    );
};


export default News;
